module.exports = __webpack_public_path__ + "static/img/y26-2.f505b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y26-2.png
// module id = 7D4g
// module chunks = 1